import { render, staticRenderFns } from "./ConfigCases.vue?vue&type=template&id=d183fcd0"
import script from "./ConfigCases.vue?vue&type=script&lang=js"
export * from "./ConfigCases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports